import { render, staticRenderFns } from "./EmployeeSalary.vue?vue&type=template&id=14d0e483"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalary.vue?vue&type=style&index=0&id=14d0e483&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports